<template>
  <div class="clock clock-modal">
    <div class="clock-content">
      <div class="loading"
           v-if="currentshow===0">数据加载中...</div>
      <div class="clock-tips"
           v-if="currentshow===1">
        <p class="txt-t">暂无设置关机时间</p>
        <p class="txt-p">您可以设置自动关机时间来让电脑进行关机/重启，睡觉前<br />也能安心挂机啦</p>
        <a href="javascript:;"
           @click="currentshow = 2"
           class="btnNml">立即设置</a>
      </div>
      <div class="clock-setting"
           v-if="currentshow===2">
        <a-form :form="form"
                :layout="formLayout"
                @submit="handleSubmit">
          <a-form-item :label-col="labelCol"
                       :wrapper-col="wrapperCol"
                       label="时间：">
            <a-form-item :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }">
              <a-date-picker style="width: 100%"
                             placeholder="请选择日期"
                             v-decorator="['day',{ rules: [{ required: true, message: '请选择日期!' }] }]" />
            </a-form-item>
            <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }"></span>
            <a-form-item :style="{ display: 'inline-block', width: 'calc(25% - 12px)' }">
              <a-time-picker style="width: 100%"
                             v-decorator="['hour',{ rules: [{ required: true, message: '请选择时钟!' }] }]"
                             format="HH"
                             placeholder="时"
                             :open.sync="open1"
                             @change="handleClose1" />
            </a-form-item>
            <span :style="{ display: 'inline-block', width: '12px', textAlign: 'center' }"></span>
            <a-form-item :style="{ display: 'inline-block', width: 'calc(25% - 12px)' }">
              <a-time-picker style="width: 100%"
                             v-decorator="['minute',{ rules: [{ required: true, message: '请选择分钟!' }] }]"
                             format="mm"
                             placeholder="分"
                             :open.sync="open2"
                             @change="handleClose2" />
            </a-form-item>
          </a-form-item>
          <a-form-item :label-col="labelCol"
                       :wrapper-col="wrapperCol"
                       label="备注：">
            <a-radio-group v-model="remind">
              <a-radio :value="1">1分钟前</a-radio>
              <a-radio :value="5">5分钟前</a-radio>
              <a-radio :value="0">不再提醒</a-radio>
            </a-radio-group>
          </a-form-item>
          <div class="btns">
            <a-button type="primary"
                      html-type="submit"
                      class="btnNml">
              立即设置
            </a-button>
          </div>
        </a-form>
      </div>
      <div class="clock-lists"
           v-if="currentshow===3">
        <div class="counttime">距离关机时间还有：
          <span v-text="intDay"></span>天
          <span v-text="intHour"></span>&nbsp;时
          <span v-text="intMinute"></span>&nbsp;分
          <span v-text="intSecend"></span>&nbsp;秒
        </div>
        <div class="row">
          <div class="col col-1">
            <p>关机设置</p>
            <p>时间：{{shutdownData.date}} <span v-text="formatTime(shutdownData.hour)"></span>:<span v-text="formatTime(shutdownData.minute)"></span></p>
            <p>提醒：<span class="txt-yellow">关机前{{shutdownData.remind_before}}分钟提醒</span></p>
          </div>
          <div class="col col-2">
            <a href="javascript:;"
               @click="editShutdownSetting">
              <svg xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink"
                   width="21px"
                   height="20px">
                <path fill-rule="evenodd"
                      fill="rgb(136, 136, 136)"
                      d="M19.715,4.718 L10.762,13.695 C10.545,13.913 10.255,14.001 9.970,13.982 C9.950,13.983 9.934,13.992 9.914,13.992 L7.065,13.992 C7.062,13.992 7.060,13.991 7.056,13.991 C7.037,13.992 7.020,14.003 7.000,14.003 C6.783,14.003 6.594,13.911 6.431,13.782 C6.168,13.601 5.986,13.325 5.986,13.000 C5.986,12.954 6.007,12.916 6.014,12.872 L6.014,10.083 C6.014,10.063 6.023,10.047 6.024,10.027 C6.008,9.746 6.097,9.461 6.312,9.246 L15.265,0.294 C15.374,0.184 15.504,0.111 15.641,0.062 C16.017,-0.094 16.466,-0.020 16.772,0.286 L19.710,3.225 C19.917,3.432 20.015,3.705 20.011,3.976 C20.015,4.244 19.919,4.513 19.715,4.718 ZM15.998,2.452 L7.986,10.463 L7.986,12.007 L9.554,12.007 L17.542,3.996 L15.998,2.452 ZM2.000,6.000 L2.000,16.000 C2.000,17.104 2.895,18.000 4.000,18.000 L14.000,18.000 C15.104,18.000 16.000,17.104 16.000,16.000 L16.000,10.000 L18.000,10.000 L18.000,18.000 C18.000,19.104 17.104,20.000 16.000,20.000 L2.000,20.000 C0.895,20.000 -0.000,19.104 -0.000,18.000 L-0.000,4.000 C-0.000,2.895 0.895,2.000 2.000,2.000 L10.000,2.000 L10.000,4.000 L4.000,4.000 C2.895,4.000 2.000,4.895 2.000,6.000 Z" />
              </svg>
            </a>
            <a href="javascript:;"
               @click="deleteShutdownSetting">
              <svg xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink"
                   width="18px"
                   height="20px">
                <path fill-rule="evenodd"
                      fill="rgb(136, 136, 136)"
                      d="M17.000,6.000 L16.000,6.000 L16.000,8.000 L16.000,16.000 C16.000,18.209 14.209,20.000 12.000,20.000 L6.000,20.000 C3.791,20.000 2.000,18.209 2.000,16.000 L2.000,8.000 L2.000,6.000 L1.000,6.000 C0.448,6.000 -0.000,5.552 -0.000,5.000 C-0.000,4.448 0.448,4.000 1.000,4.000 L2.000,4.000 L2.000,4.000 L5.000,4.000 C5.000,1.791 6.791,-0.000 9.000,-0.000 C11.209,-0.000 13.000,1.791 13.000,4.000 L16.000,4.000 L16.000,4.000 L17.000,4.000 C17.552,4.000 18.000,4.448 18.000,5.000 C18.000,5.552 17.552,6.000 17.000,6.000 ZM9.000,2.000 C7.895,2.000 7.000,2.895 7.000,4.000 L11.000,4.000 C11.000,2.895 10.105,2.000 9.000,2.000 ZM14.000,6.000 L4.000,6.000 L4.000,14.000 C4.000,16.209 5.791,18.000 8.000,18.000 L10.000,18.000 C12.209,18.000 14.000,16.209 14.000,14.000 L14.000,6.000 ZM12.000,15.000 C11.448,15.000 11.000,14.552 11.000,14.000 L11.000,9.000 C11.000,8.448 11.448,8.000 12.000,8.000 C12.552,8.000 13.000,8.448 13.000,9.000 L13.000,14.000 C13.000,14.552 12.552,15.000 12.000,15.000 ZM9.000,15.000 C8.448,15.000 8.000,14.552 8.000,14.000 L8.000,9.000 C8.000,8.448 8.448,8.000 9.000,8.000 C9.552,8.000 10.000,8.448 10.000,9.000 L10.000,14.000 C10.000,14.552 9.552,15.000 9.000,15.000 ZM6.000,15.000 C5.448,15.000 5.000,14.552 5.000,14.000 L5.000,9.000 C5.000,8.448 5.448,8.000 6.000,8.000 C6.552,8.000 7.000,8.448 7.000,9.000 L7.000,14.000 C7.000,14.552 6.552,15.000 6.000,15.000 Z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShutdownSetting',
  data () {
    return {
      formLayout: 'horizontal',
      labelCol: { span: 3 },
      wrapperCol: { span: 21 },
      currentshow: 0,
      token: '',
      id: '',
      remind: 1,
      shutdownData: '',
      shutdownSettingTimer: null,
      intDay: 0,
      intHour: 0,
      intMinute: 0,
      intSecend: 0,
      open1: false,
      open2: false
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  mounted () {
    this.Storage.get('USER', res => {
      if (res.status === 'error' || !res.data.USER) {
        return
      }
      this.token = res.data.USER.box_token
    })
    this.getShutdownSetting()
  },
  methods: {
    handleClose1 () {
      this.open1 = false
    },
    handleClose2 () {
      this.open2 = false
    },
    // 获取关机设置
    getShutdownSetting () {
      let t = this
      t.XHR({
        url: t.ports.shutdown.list,
        data: {
          token: t.token
        },
        cbFn (res) {
          if (res.status === 'error') {
            t.Toast({
              content: res.info
            })
            return
          }
          clearTimeout(t.shutdownSettingTimer)
          if (res.data.info.length === 0) {
            t.$store.commit('FNSTATE', {
              shutdownData: {}
            })
            t.currentshow = 1
            return
          }
          t.shutdownData = res.data.info
          t.remind = t.shutdownData.remind_before
          t.$store.commit('FNSTATE', {
            shutdownData: res.data.info
          })
          setTimeout(res => {
            t.currentshow = 3
            t.countShutdownTimer()
          }, 1000)
        }
      })
    },
    // 编辑列表
    editShutdownSetting () {
      let t = this
      t.currentshow = 2
      clearTimeout(this.shutdownSettingTimer)
      setTimeout(() => {
        t.form.setFieldsValue({
          'day': t.moment(t.shutdownData.date, 'YYYY-MM-DD'),
          'hour': t.moment(t.shutdownData.hour, 'HH'),
          'minute': t.moment(t.shutdownData.minute, 'mm')
        })
      }, 1000)
    },
    // 删除关机设置
    deleteShutdownSetting () {
      let t = this
      t.XHR({
        url: t.ports.shutdown.delete,
        method: 'get',
        data: { id: t.shutdownData.id },
        cbFn: res => {
          t.Toast({
            content: res.info
          })
          if (res.status === 'error') {
            return false
          }
          t.Storage.set('shutdownSecend', -1)
          this.getShutdownSetting()
        }
      })
    },
    // 表单提交
    handleSubmit (e) {
      let t = this
      e.preventDefault()
      this.form.validateFields((err, fieldsValue) => {
        if (err) {
          return
        }
        const values = {
          ...fieldsValue,
          'token': t.token,
          'day': fieldsValue['day'].format('YYYY-MM-DD'),
          'hour': fieldsValue['hour'].format('HH'),
          'minute': fieldsValue['minute'].format('mm'),
          'remind': t.remind,
          'id': t.id
        }
        t.XHR({
          url: t.ports.shutdown.add,
          method: 'get',
          data: values,
          cbFn: res => {
            t.Toast({
              content: res.info
            })
            if (res.status === 'error') {
              return false
            }
            this.getShutdownSetting()
          }
        })
      })
    },
    countShutdownTimer () {
      this.Storage.get('shutdownSecend', res => {
        let timeDistance = parseInt(res.data.shutdownSecend) || 0
        this.shutdownSettingTimer = setTimeout(() => {
          this.countShutdownTimer()
        }, 1000)
        if (timeDistance > 0) {
          this.intDay = Math.floor(timeDistance / 86400)
          timeDistance -= this.intDay * 86400
          this.intHour = Math.floor(timeDistance / 3600)
          timeDistance -= this.intHour * 3600
          this.intMinute = Math.floor(timeDistance / 60)
          timeDistance -= this.intMinute * 60
          this.intSecend = timeDistance
          if (this.intHour < 10) {
            this.intHour = '0' + this.intHour
          }
          if (this.intMinute < 10) {
            this.intMinute = '0' + this.intMinute
          }
          if (this.intSecend < 10) {
            this.intSecend = '0' + this.intSecend
          }
        } else if (timeDistance === 0) {
          this.intDay = 0
          this.intHour = 0
          this.intMinute = 0
          this.CEF.API('ShutdownOperation')
          clearTimeout(this.shutdownSettingTimer)
        } else {
          clearTimeout(this.shutdownSettingTimer)
          this.getShutdownSetting()
        }
      })
    },
    formatTime (value) {
      return parseInt(value) < 10 ? '0' + parseInt(value) : parseInt(value)
    }
  }
}
</script>

<style lang="less" scoped>
.clock {
  color: #555555;
  .loading {
    display: flex;
    height: 268px;
    align-items: center;
    justify-content: center;
  }
  &-tips {
    text-align: center;
    .txt-t {
      margin-top: 56px;
      font-size: 16px;
    }
    .txt-p {
      line-height: 28px;
      color: #888888;
    }
  }
  &-lists {
    text-align: center;
    .row {
      width: 418px;
      height: 90px;
      padding: 20px 15px;
      margin: 0 auto;
      background: #f7f7f7;
      text-align: left;
      display: flex;
      height: 100%;
      align-items: center;
      .col {
        &-1 {
          width: 80%;
          margin-left: 15px;
          p {
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            overflow: hidden;
          }
        }
        &-2 {
          a {
            margin-left: 10px;
            &:hover {
              svg path {
                fill: #f58d16;
              }
            }
          }
        }
      }
    }
    p {
      margin-bottom: 0;
    }
    .btnNml {
      margin-top: 10px;
    }
  }
  &-setting {
    padding: 20px 30px;
    .btns {
      text-align: center;
      margin: 20px auto 0;
    }
  }
  .btnNml {
    width: 100px;
    height: 30px;
    line-height: 30px;
    border-radius: 3px;
    &:hover {
      color: #fff;
    }
  }
}
.counttime {
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 20px;
  span {
    color: #fd9d2b;
  }
}
.form {
  .item {
    display: flex;
    align-items: center;
    height: 36px;
    .label {
      width: 75px;
      text-align: right;
    }
  }
}
.txt-yellow {
  color: #fd9d2b;
}
</style>
